import { useCallback, useEffect, useRef } from "react";
import { supabase } from "@/lib/supabase";
import {
  DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY,
  parseLeadDefaultFollowUpPolicy,
} from "@/lib/lead/extraction/leadDefaultFollowUpPolicy";

/** Loads org `sales_daily_checklist_config` and exposes follow-up policy for extraction (ref + getter). */
export function useLeadWorkspaceFollowUpPolicyRef(scopedOrganizationId: string | null) {
  const leadFollowUpPolicyRef = useRef(DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY);
  useEffect(() => {
    let cancelled = false;
    if (!scopedOrganizationId || !supabase) {
      leadFollowUpPolicyRef.current = DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY;
      return;
    }
    void (async () => {
      const { data, error } = await supabase
        .from("organizations")
        .select("sales_daily_checklist_config")
        .eq("id", scopedOrganizationId)
        .maybeSingle();
      if (cancelled) return;
      if (error || !data) {
        leadFollowUpPolicyRef.current = DEFAULT_LEAD_DEFAULT_FOLLOW_UP_POLICY;
        return;
      }
      leadFollowUpPolicyRef.current = parseLeadDefaultFollowUpPolicy(
        (data as { sales_daily_checklist_config?: unknown }).sales_daily_checklist_config
      );
    })();
    return () => {
      cancelled = true;
    };
  }, [scopedOrganizationId]);

  const getLeadDefaultFollowUpPolicy = useCallback(() => leadFollowUpPolicyRef.current, []);

  return { getLeadDefaultFollowUpPolicy };
}
